import { render, staticRenderFns } from "./certificats.html?vue&type=template&id=768c6cdb&scoped=true&external"
import script from "./certificats.js?vue&type=script&lang=js&external"
export * from "./certificats.js?vue&type=script&lang=js&external"
import style0 from "./certificats.scss?vue&type=style&index=0&id=768c6cdb&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768c6cdb",
  null
  
)

export default component.exports